const Location = ({ width }) => {
    return (
        <div className={`location-icon ${width}`}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 238.42 255.04">
              <g fill="currentColor">
                <path d="M119.21 254.07L46.56 130.06c-8.25-13.29-12.66-28.82-12.66-44.74C33.89 38.27 72.17 0 119.21 0s85.32 38.27 85.32 85.32c0 15.92-4.42 31.46-12.77 44.93l-72.55 123.83zm0-237.38c-37.84 0-68.63 30.79-68.63 68.63 0 12.81 3.55 25.3 10.27 36.13l58.36 99.61 58.26-99.43c6.82-11 10.37-23.5 10.37-36.31 0-37.84-30.79-68.63-68.63-68.63z"></path>
                <path d="M0 238.35H238.42V255.04H0z"></path>
                <circle cx="119.21" cy="86.58" r="23.84"></circle>
              </g>
            </svg>
        </div>
    )
}

export default Location
